import { useQuery } from 'react-query';

import { getMCTMonitoring } from 'api/reports/getMCTMonitoring';

export const useGetMCTMonitoring = (
  slug: string,
  start_date: string,
  end_date: string,
  filter_type?: string,
  enabled: boolean = true,
) => {
  const { data, refetch, isRefetching, isLoading } = useQuery(
    'mctMonitoring',
    () => getMCTMonitoring(slug, start_date, end_date, filter_type || 'default'),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isRefetching, isLoading };
};

export default useGetMCTMonitoring;
